module.exports = __webpack_public_path__ + "img/其他设备-r.00c1fafe.png";